<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '银行卡名称', prop: 'name', minWidth: '120' },
        { label: '开户行', prop: 'name', minWidth: '220' },
        { label: '银行卡卡号', prop: 'brandName', minWidth: '120' },
        { label: '持卡人姓名', prop: 'categoryName', minWidth: '120' }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

